import { MutableRefObject, useCallback, useEffect, useRef } from "react"
import { NextRouter } from "next/router"
import { useActor } from "@xstate/react"
import { useBrowserNavigation } from "../../../_common/hooks/use-on-browser-back"
import { Command, diffUrlQueryParams } from "../../../_common/diff-url-query-params"
import { extractNormalQueryParams } from "../../../_common/routing"
import { ECommerceService } from "../machines/ecommerce-machine/e-commerce-machine"
import { useWorkQueueMachine } from "../../../_common/machines/machines-context"
import { commandToActionV3 } from "./diff-helpers-v3"
import { usePreviousIfDifferent } from "./use-previous-if-different"

export const useSyncStateOnHistoryNavigationV3 = (
    isRestoreComplete: MutableRefObject<boolean>,
    router: NextRouter,
    ecommerce: ECommerceService,
) => {
    const [, send] = useActor(ecommerce)
    const [, sendWQ] = useWorkQueueMachine()
    const triggeredByBackOrForward = useRef(false)

    // NOTE: router query see the updated value too late to be useful
    // const currentQuery = router.query
    const currentQuery = Object.fromEntries(new URLSearchParams(global?.location?.search || ""))
    const currQuery = extractNormalQueryParams(currentQuery)
    const prevQuery = usePreviousIfDifferent(currQuery)

    const onPopState = useCallback(() => {
        triggeredByBackOrForward.current = true
    }, [])
    useBrowserNavigation(router, onPopState)

    useEffect(() => {
        if (!isRestoreComplete.current) return

        if (!prevQuery.ref.current.isDifferent) return

        if (!triggeredByBackOrForward.current) return
        triggeredByBackOrForward.current = false

        const diffs = diffUrlQueryParams(prevQuery.ref.current.prev, currQuery)
        // console.log("diffs", prettyDiffs(diffs))

        const toEcommerceAction = commandToActionV3(send, ecommerce)
        diffs
            .map((c) => ({ id: commandId(c), action: toEcommerceAction(c) }))
            .forEach((action) => {
                sendWQ({ type: "ENQUEUE", key: action.id, action: action.action })
            })

        prevQuery.resetIsDifferent()
    })
}

const prettyDiffs = (diffs: Command[]) => diffs.map(commandId)
const commandId = (command: Command) => `${command.type}-${command.key}`
